import React, { useState } from 'react';
import { Modal } from "antd";
import { PlayCircleOutlined } from '@ant-design/icons';

interface VideoPlayerProps {
    url: string;
    width?: number;
    height?: number;
    thumbnail?: string;
}

const VideoPlayer = ({ url, width = 80, height = 60, thumbnail }: VideoPlayerProps) => {
    const [previewVisible, setPreviewVisible] = useState(false);
    const [isHovered, setIsHovered] = useState(false);

    const handlePreview = () => {
        setPreviewVisible(true);
    };

    return (
        <>
            <div
                style={{
                    position: 'relative',
                    width: `${width}px`,
                    height: `${height}px`,
                    borderRadius: '8px',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    border: '1px solid #d9d9d9',
                    background: '#f5f5f5'
                }}
                onClick={handlePreview}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                {thumbnail ? (
                    <img
                        src={thumbnail}
                        alt="Video thumbnail"
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                ) : (
                    <video
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                        muted
                    >
                        <source src={url} type="video/mp4"/>
                    </video>
                )}

                {/* Play button overlay */}
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: 'white',
                        fontSize: '24px',
                        textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                        transition: 'all 0.3s ease'
                    }}
                >
                    <PlayCircleOutlined rev={undefined} />
                </div>

                {/* Hover overlay */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0,0,0,0.3)',
                        opacity: isHovered ? 1 : 0,
                        transition: 'opacity 0.3s ease'
                    }}
                />
            </div>

            <Modal
                open={previewVisible}
                footer={null}
                onCancel={() => setPreviewVisible(false)}
                width="80%"
                centered
                style={{ maxWidth: '800px' }}
            >
                <video
                    style={{
                        width: '100%',
                        maxHeight: '70vh',
                        borderRadius: '8px'
                    }}
                    src={url}
                    controls
                    autoPlay
                />
            </Modal>
        </>
    );
};

export default VideoPlayer;